var config = {
    apiUrl: process.env.VUE_APP_API_URL || "http://" + window.location.hostname + ':8000',
    apiUrlPrefix: "/api"
}

export default config;